
import Vue from 'vue';
import api from './api';

Vue.mixin({
    beforeCreate() {
        // Removed old V0 code
    },
});

export default api;
